import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseDownstreamLensesQueryVariables, DatabaseDownstreamLensesQuery, LensesDisplayGridRowDataFragment, DatabaseDownstreamLensesFilteredByTableQueryVariables, DatabaseDownstreamLensesFilteredByTableQuery, LensSortOrder , DatabaseDownstreamLensesFilteredByTableDocument , DatabaseDownstreamLensesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  LensesDisplayGrid,
  LensesDisplayGridRowData,
  getRowDataForLens,
} from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = DatabaseDownstreamLensesQueryVariables;
type QueryResults = DatabaseDownstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseDownstreamLensesFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseDownstreamLensesFilteredByTableQuery;


function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.databases && resultData.databases[0]?.downstreamLensesConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.tables && resultData.tables[0]?.downstreamLensesConnection;
}

export type DatabaseDownstreamLensesQueryGridProps = GridSortProps<LensesValidSortFields> & {
  readonly databaseId: string;
  readonly filteredTableId: string | null;
  readonly rowCount: number | null;
};

export function DatabaseDownstreamLensesQueryGrid(props: DatabaseDownstreamLensesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamLensesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredLensesLineageGridMessage();

  return props.filteredTableId ? (
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={DatabaseDownstreamLensesFilteredByTableDocument}
      partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as LensSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) =>
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  ) : (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={DatabaseDownstreamLensesDocument}
      partialQueryVariables={{ id: props.databaseId, orderBy: props.orderBy as LensSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) =>
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
}
